import React, { useState, startTransition, useEffect } from "react";
import Header from "../../components/Header/index";
import { FaMicrophone } from "react-icons/fa";
import { RiVoiceprintLine } from "react-icons/ri";
import { FaPlay, FaPause } from "react-icons/fa";
import Topbar from "../../components/Topbar";
import Scene from "../../components/Animation";
import Bottombar from "../../components/Bottombar";
import {ReactComponent as SelectorIcon} from "../../assets/svgs/selector.svg";
function SpeachToSignLanguage() {
  const [showmic, setMic] = useState(true);
  const [showScene, setShowScene] = useState(false);
  const [playAnimation, setPlayAnimation] = useState(0);
  const [conversation, setConversation] = useState([]);
  const [isAnimationPaused, setIsAnimationPaused] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  
  // Conversation data structure:
  // {
  //   id: string,
  //   type: 'user' | 'animation',
  //   timestamp: Date,
  //   content: string, // for user messages
  //   actions?: string[], // for animation responses - list of animation actions played
  //   animationName?: string // name of the main animation used
  // }

  const startrecording = () => {
    setMic(!showmic);
    setIsRecording(!isRecording);
  };

  const addUserMessage = (text) => {
    const userMessage = {
      id: Date.now().toString() + '_user',
      type: 'user',
      timestamp: new Date(),
      content: text
    };
    const animationResponse = {
      id: Date.now().toString() + '_animation',
      type: 'animation',
      timestamp: new Date(),
      actions: ['export_root|Take 001|BaseLayer'], // Using the animation name we found: will be dynamic in real use
      animationName: 'Sign Language Response'
    };
    
    setConversation(prev => [...prev, userMessage, animationResponse]);
    setPlayAnimation(prev => prev + 1); // Trigger animation with incrementing value
  };

  const clearConversation = () => {
    setConversation([]);
  };

  useEffect(() => {
    if (!showScene) {
      startTransition(() => {
        setShowScene(true);
      });
    }
  }, [showScene]);

  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(" Speech to Sign Language");
  const options = [
    { label: "Sign language to text ", link: "/signlanguagetotext" },

    { label: "Text to sign langauge", link: "/textandspeechtosignlanguage" },
    { label: "Text to Sign Language", link: "/textandspeechtosignlanguage" },
  ];

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (option) => {
    setSelectedOption(option.label);
    setIsOpen(false);
    // Navigate to the selected option's link
    window.location.href = option.link;
  };

  return (
    <div className="overflow-auto  h-[110vh]">
    <div className="">
      <div
        className="hidden md:block
      "
      >
        <Header />
      </div>

      <div className="sm:hidden">
        <Topbar />
      </div>
    </div>

    <div className="flex flex-col sm:flex-row sm:mt-4 mt-2 overflow-hidden sm:space-x-5 sm:mb-3 sm:mx-6 sm:ml-3 sm:px-0 px-2 space-y-4 sm:space-y-0">
      <div className="w-full max-w-[578px] h-[550px] bg-bgimage2 relative hidden md:block rounded-[31px] bg-[#417FEA1C] bg-center justify-center items-center">
        <div className="relative inline-block text-left">
          <div
            onClick={toggleDropdown}
            className="w-full h-10 items-center flex sm:w-[578px] z-40 cursor-pointer justify-end bg-[#2A71E8] rounded-[31px] top-5"
          >
            <div className="items-center space-x-32 flex px-10">
              <p className="text-white font-bold">{selectedOption}</p>

<SelectorIcon />
            </div>
          </div>

          {isOpen && (
            <div className="absolute right-0 mt-2 w-full ring-1 z-40 ring-black ring-opacity-0 space-y-10 h-[56px]">
              <div className="py-1 space-y-2 rounded-[25px] items-center px-5">
                {options.map((option) => (
                  <button
                    key={option.label}
                    onClick={() => handleOptionClick(option)}
                    className="w-full bg-[#D9D9D9] px-4 py-2 rounded-[25px] h-10 items-center justify-center flex space-y-5 text-left text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                  >
                    {option.label}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
        <div className=" items-center justify-center ml-4 mr-4 hidden md:block">
          {/* Conversation Display */}
          <div className="absolute top-[80px] left-[20px] right-[20px] bottom-[140px] overflow-y-auto bg-gray-50 rounded-lg p-4 border">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold text-gray-800">Conversation</h3>
              <button 
                onClick={clearConversation}
                className="bg-red-500 text-white px-3 py-1 rounded-lg hover:bg-red-600 transition-colors text-sm"
              >
                Clear Chat
              </button>
            </div>
            
            {conversation.length === 0 ? (
              <div className="text-center text-gray-500 mt-8">
                <p>Start a conversation by speaking into the microphone</p>
              </div>
            ) : (
              <div className="space-y-4">
                {conversation.map((message) => (
                  <div key={message.id} className={`flex ${message.type === 'user' ? 'justify-start' : 'justify-end'}`}>
                    <div className="flex flex-col max-w-xs">
                      <div className={`px-4 py-2 rounded-lg ${
                        message.type === 'user' 
                          ? 'bg-blue-500 text-white' 
                          : 'bg-green-500 text-white'
                      }`}>
                        {message.type === 'user' ? (
                          <p>{message.content}</p>
                        ) : (
                          <div className="flex items-center justify-between">
                            <p className="text-sm font-semibold">{message.animationName}</p>
                            <button 
                              onClick={() => setPlayAnimation(prev => prev + 1)}
                              className="bg-white/20 hover:bg-white/30 rounded p-1 ml-2"
                            >
                              <FaPlay size={12} />
                            </button>
                          </div>
                        )}
                      </div>
                      <p className="text-xs text-gray-500 mt-1 text-center">
                        {message.timestamp.toLocaleTimeString()}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
          
          {/* Desktop Recording Controls */}
          <div className="absolute bottom-[20px] left-[20px] right-[20px]">
            <div className="bg-white/95 backdrop-blur-sm rounded-lg p-4 shadow-lg border">
              <div className="flex items-center justify-center space-x-4">
                <button
                  onClick={startrecording}
                  className={`px-6 py-3 rounded-lg flex items-center space-x-3 transition-all duration-300 shadow-md font-semibold ${
                    isRecording 
                      ? 'bg-red-500 hover:bg-red-600 text-white animate-pulse' 
                      : 'bg-blue-500 hover:bg-blue-600 text-white'
                  }`}
                >
                  {isRecording ? (
                    <div className="w-4 h-4 bg-white rounded-sm"></div>
                  ) : (
                    <FaMicrophone size={18} />
                  )}
                  <span>{isRecording ? 'Stop Recording' : 'Start Recording'}</span>
                </button>
                <div className={`text-sm font-medium ${
                  isRecording ? 'text-red-600' : 'text-gray-600'
                }`}>
                  {isRecording ? 'Recording in progress...' : 'Ready to record'}
                </div>
              </div>
            </div>
          </div>
        </div>

        
      </div>

      {/* Mobile Dropdown and Conversation */}
      <div className="items-center flex flex-col pt-4 sm:hidden mb-6 px-2">
        <div className="relative inline-block text-left z-40 bg-[#D9D9D980] rounded-[25px] mb-4">
          <div
            onClick={toggleDropdown}
            className="w-[310px] h-14 items-center flex cursor-pointer justify-end bg-[#2A71E8] rounded-[25px] top-5"
          >
            <div className="items-center space-x-10 flex px-4">
              <p className="text-white font-bold">{selectedOption}</p>
              <SelectorIcon />
            </div>
          </div>

          {isOpen && (
            <div className="absolute right-0 mt-2 w-[310px] ring-1 ring-black ring-opacity-0 space-y-10 h-[56px] mr-6">
              <div className="py-1 space-y-2 rounded-[25px] items-center px-5">
                {options.map((option) => (
                  <button
                    key={option.label}
                    onClick={() => handleOptionClick(option)}
                    className="w-[310px] bg-[#D9D9D9] px-4 py-2 rounded-[25px] h-10 items-center justify-center flex space-y-5 text-left text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                  >
                    {option.label}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Mobile Conversation Display */}
        <div className="w-[350px] h-[200px] overflow-y-auto bg-gray-50 rounded-lg p-3 border mb-4">
          <div className="flex justify-between items-center mb-3">
            <h3 className="text-sm font-semibold text-gray-800">Conversation</h3>
            <button 
              onClick={clearConversation}
              className="bg-red-500 text-white px-2 py-1 rounded-lg hover:bg-red-600 transition-colors text-xs"
            >
              Clear
            </button>
          </div>
          
          {conversation.length === 0 ? (
            <div className="text-center text-gray-500 mt-6">
              <p className="text-sm">Start a conversation by speaking</p>
            </div>
          ) : (
            <div className="space-y-3">
              {conversation.map((message) => (
                <div key={message.id} className={`flex ${message.type === 'user' ? 'justify-start' : 'justify-end'}`}>
                  <div className="flex flex-col max-w-[250px]">
                    <div className={`px-3 py-2 rounded-lg text-sm ${ 
                      message.type === 'user' 
                        ? 'bg-blue-500 text-white' 
                        : 'bg-green-500 text-white'
                    }`}>
                      {message.type === 'user' ? (
                        <p>{message.content}</p>
                      ) : (
                        <div className="flex items-center justify-between">
                          <p className="text-xs font-semibold">{message.animationName}</p>
                          <button 
                            onClick={() => setPlayAnimation(prev => prev + 1)}
                            className="bg-white/20 hover:bg-white/30 rounded p-1 ml-2"
                          >
                            <FaPlay size={10} />
                          </button>
                        </div>
                      )}
                    </div>
                    <p className="text-xs text-gray-500 mt-1 text-center">
                      {message.timestamp.toLocaleTimeString()}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        
        {/* Mobile Recording Controls */}
        <div className="w-[350px]">
          <div className="bg-white/95 backdrop-blur-sm rounded-lg p-4 shadow-lg border">
            <div className="flex flex-col items-center space-y-3">
              <button
                onClick={startrecording}
                className={`w-full py-3 rounded-lg flex items-center justify-center space-x-3 transition-all duration-300 shadow-md font-semibold ${
                  isRecording 
                    ? 'bg-red-500 hover:bg-red-600 text-white animate-pulse' 
                    : 'bg-blue-500 hover:bg-blue-600 text-white'
                }`}
              >
                {isRecording ? (
                  <div className="w-4 h-4 bg-white rounded-sm"></div>
                ) : (
                  <FaMicrophone size={16} />
                )}
                <span>{isRecording ? 'Stop Recording' : 'Start Recording'}</span>
              </button>
              <div className={`text-sm font-medium text-center ${
                isRecording ? 'text-red-600' : 'text-gray-600'
              }`}>
                {isRecording ? 'Recording in progress...' : 'Ready to record'}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Desktop Animation Container */}
      <div className="hidden bg-bg6 w-full max-w-[600px] h-[550px] rounded-[30px] md:flex md:flex-col bg-cover bg-center relative">
        <button 
          onClick={() => setIsAnimationPaused(prev => !prev)}
          className="absolute top-2 right-2 z-10 bg-black/50 hover:bg-black/70 text-white rounded-full w-8 h-8 flex items-center justify-center transition-colors"
        >
          {isAnimationPaused ? <FaPlay size={14} /> : <FaPause size={14} />}
        </button>
        <div className="flex-1 w-full h-full">
          {showScene && <Scene playAnimation={playAnimation} isPaused={isAnimationPaused} />}
        </div>
        
        <div className="bg-white/90 backdrop-blur-sm rounded-b-[30px] p-4 mt-2">
          <h3 className="text-sm font-semibold text-gray-800 mb-2">3D Model Controls</h3>
          <p className="text-xs text-gray-600">Click and drag to rotate the model horizontally</p>
        </div>
      </div>

      {/* Mobile Animation Container */}
      <div className="justify-center items-center flex sm:hidden px-2">
        <div className="bg-bg6 w-full max-w-[400px] h-[450px] rounded-[30px] flex flex-col bg-cover bg-center relative">
          <button 
            onClick={() => setIsAnimationPaused(prev => !prev)}
            className="absolute top-2 right-2 z-10 bg-black/50 hover:bg-black/70 text-white rounded-full w-8 h-8 flex items-center justify-center transition-colors"
          >
            {isAnimationPaused ? <FaPlay size={14} /> : <FaPause size={14} />}
          </button>
          <div className="flex-1 w-full h-full">
            {showScene && <Scene playAnimation={playAnimation} isPaused={isAnimationPaused} />}
          </div>
          
          <div className="bg-white/90 backdrop-blur-sm rounded-b-[30px] p-3">
            <h3 className="text-sm font-semibold text-gray-800 mb-2">3D Model Controls</h3>
            <p className="text-xs text-gray-600">Click and drag to rotate</p>
          </div>
        </div>
      </div>
    </div>
    <div className=" sm:border-[1px] sm:w-[1364px] w-[123px] border-[#878787] ml-3  hidden  md:block "></div>

    <div className="sm:hidden bottom-0 fixed w-full">
      <Bottombar activeBar={'input'} />
    </div>
  </div>
  );
}

export default SpeachToSignLanguage;
